<script setup lang="ts">
import { StackLayout, TypographyItem } from '@rfc/rfc-components-library'
import { isNullOrUndefined } from '@rfc/rfc-components-library/utils'

type Props = {
    data: { label: string; value?: number | string }
}
defineProps<Props>()
</script>

<template>
    <StackLayout direction="column" class="section-text checkpoint-stats">
        <TypographyItem
            :label="!isNullOrUndefined(data.value) ? data.value?.toString() : $t('common.unknown')"
            class=""
            style="font-size: 1.5rem" />
        <TypographyItem :label="data.label" />
    </StackLayout>
</template>

<style scoped lang="scss">
.checkpoint-section-content {
    overflow-y: scroll;
}

.checkpoints-list {
    padding: 1em;
}
</style>
